import { TRegionKey } from '@source/interface';
import { FC } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

interface DiscountRibbonProps {
  discount: string;
  countryCode: TRegionKey;
  currency: string;
}

const StyledDiscountRibbon = styled.div`
  background-color: #ffe4d9;
  padding: 5px 20px;
  border-top-right-radius: 8px;

  .label {
    ${({ theme }) => theme.typo.familyGoogle.semiBold};
    color: ${({ theme }) => theme.color.primaryBase};
    font-size: 12px;
    line-height: 16px;

    @media only screen and (min-width: ${({ theme }) => theme.metrics.breakpoints.lg}) {
      font-size: 13px;
    }
  }

  @media only screen and (min-width: ${({ theme }) => theme.metrics.breakpoints.lg}) {
    padding: 5px 19.56px;
  }
`;

const DiscountRibbon: FC<DiscountRibbonProps> = ({ discount, countryCode, currency }) => (
  <StyledDiscountRibbon>
    <div className="label">
      <Trans
        i18nKey={`buyNew.listingCard.discountPrice.${countryCode}`}
        values={{
          currency,
          value: discount,
        }}
      />
    </div>
  </StyledDiscountRibbon>
);

const StyledWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
`;

const DiscountRibbonWrapper: FC<DiscountRibbonProps> = (props) => (
  <StyledWrapper>
    <DiscountRibbon {...props} />
  </StyledWrapper>
);

export { DiscountRibbonWrapper };
export default DiscountRibbon;
